import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';

import { useShareHeadline } from '../../../../hooks/shareHeadline';

export const DEFAULT_PHOTO = { url: 'https://static.change.org/images/default-petition.gif', width: 1120, height: 630 };

type UseMetaImageTags = ModelHookResult<{
	ogImage: string;
	ogImageWidth: string;
	ogImageHeight: string;
	ogTwitterImage: string;
}>;

export function useMetaImageOgTags(): UseMetaImageTags {
	const {
		data: {
			petition: { photo, bestShareVisual },
		},
	} = usePetitionDetailsPageData();
	const { resolveUrl } = useUtilityContext();
	const shareHeadline = useShareHeadline();

	// Check for best share visual flag
	const bestShareVisualParam = useQueryParamValue('best_share_visual');
	const shouldUseBestShareVisual = bestShareVisualParam === '1';

	// Extract custom share image from ReadyToSharePost (Share for Starters campaigns)
	let previewLinkImage;
	if (shareHeadline?.imageUrl) {
		previewLinkImage = {
			...DEFAULT_PHOTO,
			url: shareHeadline.imageUrl,
		};
	}

	// Determine OG image by priority
	// Default: Petition photo or default
	let metaPhoto = photo?.petitionLarge || DEFAULT_PHOTO;

	if (previewLinkImage) {
		// Priority 1: Custom share campaign image (don't break existing campaigns)
		metaPhoto = previewLinkImage;
	} else if (shouldUseBestShareVisual && bestShareVisual?.url) {
		// Priority 2: AI-generated share visual (gated by query param)
		metaPhoto = {
			...DEFAULT_PHOTO,
			url: bestShareVisual.url,
		};
	}

	const imageUrl = resolveUrl(metaPhoto.url);

	return {
		data: {
			ogImage: imageUrl,
			ogImageWidth: `${metaPhoto.width}`,
			ogImageHeight: `${metaPhoto.height}`,
			ogTwitterImage: imageUrl,
		},
	};
}
